// extracted by mini-css-extract-plugin
export default {"listWrapper":"adItem_listWrapper__Id8oi","listKey":"adItem_listKey__zhqjU","listValue":"adItem_listValue__vaaeS"};